export const BASE_API_URL = "https://rickandmortyapi.com/api";

export const BASE_CHARACTER_API_URL = `${BASE_API_URL}/character`;
export const BASE_EPISODE_API_URL = `${BASE_API_URL}/episode`;
